import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { RestApiService } from '../common-app/service/rest-api.service';
import { Kvaw0500Vo } from './kvaw0500.vo';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0500（日報情報取得（表示））.xlsx
 */
@Injectable()
export class Kvaw0500Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0500';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 日報詳細情報（表示用情報）を取得する
   *
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   */
  searchReportDetailForDisplay(storeCode?: string, deliveryDate?: string): Observable<Kvaw0500Vo> {
    const query = {
      storeCode: storeCode,
      deliveryDate: deliveryDate,
    };

    return this.restApiService.search<Kvaw0500Vo>(Kvaw0500Service.TARGET, query);
  }

  /**
   * 日報詳細情報（担当店外一覧から遷移した場合の表示用情報）を取得する
   *
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   * @param chainCode チェーンコード
   * @param chainCodeBranchNum チェーンコード枝番
   * @param kaibaCode 買場コード
   */
  searchReportDetailForDisplayOutside(storeCode?: string, deliveryDate?: string, chainCode?: string, chainCodeBranchNum?: string, kaibaCode?: string): Observable<Kvaw0500Vo> {
    const query = {
      storeCode: storeCode,
      deliveryDate: deliveryDate,
      chainCode: chainCode,
      chainCodeBranchNum: chainCodeBranchNum,
      kaibaCode: kaibaCode,
    };

    return this.restApiService.search<Kvaw0500Vo>(Kvaw0500Service.TARGET, query);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0500.service.ts